import { ReactComponent as DefaultIcon } from 'new/components/icons/fi-rr-info.svg';
import { ReactComponent as SuccessIcon } from './icons/success.svg';
import { ReactComponent as WarnIcon } from './icons/warn.svg';

export default function (variant: string) {
  let response = {
    Icon: DefaultIcon,
    textStyle: { color: 'var(--color-greyscale-600)' },
    containerStyle: {
      backgroundColor: 'var(--color-greyscale-0)',
      border: '1px solid var(--color-greyscale-600)',
    },
  };

  switch (variant) {
    case 'default':
      break;
    case 'success':
      response.Icon = SuccessIcon;
      response.textStyle = { color: 'var(--color-success-700)' };
      response.containerStyle = {
        backgroundColor: 'var(--color-success-100)',
        border: '1px solid var(--color-success-700)',
      };
      break;
    case 'warning':
      response.Icon = WarnIcon;
      response.textStyle = { color: 'var(--color-warning-700)' };
      response.containerStyle = {
        backgroundColor: 'var(--color-warning-100)',
        border: '1px solid var(--color-warning-700)',
      };
      break;
    case 'error':
      response.Icon = WarnIcon;
      response.textStyle = { color: 'var(--color-danger-700)' };
      response.containerStyle = {
        backgroundColor: 'var(--color-danger-200)',
        border: '1px solid var(--color-danger-700)',
      };
      break;
    default:
      console.error('the variant is not a valid value');
  }
  return response;
}
